import { useState } from 'react';
import { useSearchParams } from 'react-router-dom';
import { Icon } from '@iconify/react';
import ExpenseHeader from './expense-header.jsx';
import ExpensePage from './expense-page.jsx';
import CashWithdrawal from './cash-withdrawal.jsx';
import "../../../styles/Auth/expense.css";
import { ALL_STORE_OPTION } from '../../Challange/StoreSingleAllStoresSelect.jsx';

const Expense = () => {
    const [expenses, setExpenses] = useState([]); // list of expenses
    const [totals, setTotals] = useState({}); // totals object
    const [totalCount, setTotalCount] = useState(0); // total count
    const [totalPages, setTotalPages] = useState(0); // total pages
    const [currentPage, setCurrentPage] = useState(1);
    const [store, setStore] = useState(ALL_STORE_OPTION);
    const [refreshKey, setRefreshKey] = useState(0);
    const [sortField, setSortField] = useState("createdAt");
    const [sortOrder, setSortOrder] = useState(-1);
    const [limit, setLimit] = useState(5);

    const [searchParams, setSearchParams] = useSearchParams();
    const activeTab = searchParams.get("tab") === "withdrawals" ? "withdrawals" : "expenses";

    const handleTabChange = (tab) => {
        if (tab === "withdrawals") {
            setSearchParams({ tab: "withdrawals" });
        } else {
            setSearchParams({});
        }
    };

    const handleSort = (field) => {
        const newOrder = sortField === field ? (sortOrder === 1 ? -1 : 1) : -1;
        setSortField(field);
        setSortOrder(newOrder);
    };

    const triggerRefresh = () => {
        setRefreshKey(prev => prev + 1);
    };

    return (
        <div className="product-layout">
            <div className="product-content">
                <div className="expense-tabs" role="tablist">
                    <button
                        role="tab"
                        aria-selected={activeTab === "expenses"}
                        className={`expense-tab ${activeTab === "expenses" ? "active" : ""}`}
                        onClick={() => handleTabChange("expenses")}
                    >
                        <Icon icon="mdi:receipt-text-outline" width={19} height={19} />
                        Expenses
                    </button>
                    <button
                        role="tab"
                        aria-selected={activeTab === "withdrawals"}
                        className={`expense-tab ${activeTab === "withdrawals" ? "active" : ""}`}
                        onClick={() => handleTabChange("withdrawals")}
                    >
                        <Icon icon="mdi:bank-transfer-out" width={20} height={20} />
                        Bank Transfer / Self Withdrawal
                    </button>
                </div>

                {activeTab === "withdrawals" ? (
                    <main className="product-main">
                        <CashWithdrawal />
                    </main>
                ) : (
                    <>
                        <main className="product-main">
                            <ExpenseHeader
                                onDataFetched={(data, totals, totalCount, totalPages) => {
                                    setExpenses(data);
                                    setTotals(totals);
                                    setTotalCount(totalCount);
                                    setTotalPages(totalPages);
                                }}
                                totals={totals}
                                currentPage={currentPage}
                                limit={limit}
                                store={store}
                                refreshKey={refreshKey}
                                sortField={sortField}
                                sortOrder={sortOrder}
                            />
                        </main>

                        <div>
                            {/* 🔹 Pass expenses into table */}
                            <ExpensePage
                                expenses={expenses}
                                totalCount={totalCount}
                                totalPages={totalPages}
                                currentPage={currentPage}
                                setCurrentPage={setCurrentPage}
                                limit={limit}
                                setLimit={setLimit}
                                store={store}
                                onRefresh={triggerRefresh}
                                sortField={sortField}
                                sortOrder={sortOrder}
                                handleSort={handleSort}
                            />
                        </div>
                    </>
                )}
            </div>
        </div>
    );
};

export default Expense;